import './scss/main.scss'
import React, { Component } from 'react'

import logoCertif from './logo/calidad.png'
import MainApp from './modules/MainApp/containers/MainApp'
import { connect } from 'react-redux'
import * as actions from './modules/Utils/actions'

class App extends Component {
  render () {
    const { showFooter = false } = this.props
    return (
      <div className='App'>
        <div className='App-container'>
          <MainApp />
        </div>
        {showFooter && <footer className='App-footer'>
          <div className='float-center'>
            <h6 className='App-copyright'> Todos los derechos reservados © 2010-2024 Terminal Quequén S.A.</h6>
            <img src={logoCertif} className='App-inst-logo' alt='logo' />
          </div>
        </footer>}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  showFooter: state.utils.showFooter
})

const withRedux = connect(mapStateToProps, actions)
export default withRedux(App)
